import { useCallback } from 'react';

import { dateUtils } from 'shared_DEPRECATED/utils';

import { ChatMessageScheduleModalContent } from 'features/chat/components/ChatMessagesScheduling';
import { ScheduledForCallback } from 'features/chat/config/types/ScheduledMessage';
import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';
import { useParticipantTimeZone } from 'features/participants/hooks/useParticipantTimeZone';

import { modal, SIZES } from 'shared/components/Modal';

export const useShowScheduledModal = () => {
  const { email } = useChatInterlocutorContext();
  const timezone = useParticipantTimeZone(email);

  return useCallback(
    (onSubmit: ScheduledForCallback, scheduledFor?: string) => {
      modal.open({
        content: (
          <ChatMessageScheduleModalContent
            onSubmit={onSubmit}
            scheduledForDate={
              scheduledFor ? dateUtils(scheduledFor).toDate() : undefined
            }
          />
        ),
        props: { size: SIZES.AUTO },
        context: { timezone },
      });
    },
    [timezone]
  );
};
